const PM_CONTAINER = 'pmContainer';
const PM_CONTENT = 'pmContent';
const PM_CLOSE_CONTAINER = 'pmCloseContainer';
const PM_TITLE = 'pmTitle';
const PM_SUBTITLE = 'pmSubtitle';
const PM_CHILDREN = 'pmChildren';

export { PM_CONTAINER, PM_CONTENT, PM_CLOSE_CONTAINER, PM_TITLE, PM_SUBTITLE, PM_CHILDREN };
